/**
 * Kiyoh Reviews Widget - Entry Point
 */

import KiyohReviewsWidget from './KiyohReviewsWidget.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  console.log('[Kiyoh Reviews Widget] Initialized');
}

export { KiyohReviewsWidget };
